import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import Button from 'Components/LegacyButton';
import TextImage from 'Components/TextImage';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import { customHaircare as customHaircareData } from 'assets/content/home';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const HairCareHero = ({ heroContent }) => {
  const { isMobile } = useResponsiveVariant();

  const { title, cta, description, imageMobile, imageDesktop, imageAlt, primaryTitle } =
    heroContent;

  return (
    <TextImage
      contentAlign="left"
      contentAlignMob="left"
      description={description}
      DescriptionProps={{ color: 'noir', style: { width: 265 } }}
      hasImageBorder
      imageAlt={imageAlt}
      imageDesktop={imageDesktop}
      imageMobile={imageMobile}
      screenWidth={{ 1: isMobile ? '100%' : '56%', 2: isMobile ? '100%' : '44%' }}
      subTitle={title}
      title={primaryTitle}
      TitleProps={{ variant: isMobile ? 'h1' : 'hero2' }}
    >
      <Button
        Component={Link}
        data-click="explore-haircare"
        data-from="haircare-grid"
        to={cta.path}
        variant="noir"
      >
        {cta.label}
      </Button>
    </TextImage>
  );
};

HairCareHero.defaultProps = {
  heroContent: customHaircareData,
};

HairCareHero.propTypes = {
  heroContent: PropTypes.shape({
    imageAlt: PropTypes.string,
    imageMobile: srcOrNextImageProp,
    imageDesktop: srcOrNextImageProp,
    title: PropTypes.string,
    primaryTitle: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.shape({ label: PropTypes.string, path: PropTypes.string }),
  }),
};

export default HairCareHero;
